import _async_to_generator from "@swc/helpers/src/_async_to_generator.mjs";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import _sliced_to_array from "@swc/helpers/src/_sliced_to_array.mjs";
import _ts_generator from "@swc/helpers/src/_ts_generator.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useRef, useEffect, useState } from "react";
import { Box, Icon, Flex, FormControl, FormLabel, Spacer, useBoolean, FormHelperText } from "@chakra-ui/react";
import { CheckIcon } from "@inspire/ui/icons";
import Select from "@inspire/ui/chakra/forms/Select";
import Spinner from "@inspire/ui/chakra/Spinner";
export var StandaloneSelect = function(_param) {
    var instanceId = _param.instanceId, options = _param.options, onChange = _param.onChange, onError = _param.onError, value = _param.value, label = _param.label, _isRequired = _param.isRequired, isRequired = _isRequired === void 0 ? false : _isRequired, _maxW = _param.maxW, maxW = _maxW === void 0 ? 400 : _maxW, isLoading = _param.isLoading, helperText = _param.helperText, formControlProps = _object_without_properties(_param, [
        "instanceId",
        "options",
        "onChange",
        "onError",
        "value",
        "label",
        "isRequired",
        "maxW",
        "isLoading",
        "helperText"
    ]);
    var ref = _sliced_to_array(useBoolean(false), 2), isConfirmed = ref[0], ref1 = ref[1], enableIsConfirmed = ref1.on, disableIsConfirmed = ref1.off;
    var ref2 = _sliced_to_array(useBoolean(false), 2), isSubmitting = ref2[0], ref3 = ref2[1], enableIsSubmitting = ref3.on, disableIsSubmitting = ref3.off;
    var confirmedTimeoutRef = useRef(null);
    var ref4 = useState(null), optimisticSelectedOption = ref4[0], setOptimisticSelectedOption = ref4[1];
    var handleChange = function() {
        var _ref = _async_to_generator(function(option) {
            var err;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        enableIsSubmitting();
                        clearTimeout(confirmedTimeoutRef.current);
                        setOptimisticSelectedOption(option);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            onChange(option)
                        ];
                    case 2:
                        _state.sent();
                        enableIsConfirmed();
                        confirmedTimeoutRef.current = setTimeout(function() {
                            disableIsConfirmed();
                            setOptimisticSelectedOption(null);
                        }, 2000);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        err = _state.sent();
                        onError && onError(err);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        disableIsSubmitting();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleChange(option) {
            return _ref.apply(this, arguments);
        };
    }();
    useEffect(function() {
        return function() {
            return clearTimeout(confirmedTimeoutRef.current);
        };
    }, []);
    return /*#__PURE__*/ _jsxs(FormControl, _object_spread_props(_object_spread({
        isRequired: isRequired
    }, formControlProps), {
        children: [
            label && /*#__PURE__*/ _jsx(FormLabel, {
                htmlFor: "react-select-".concat(instanceId, "-input"),
                children: label
            }),
            /*#__PURE__*/ _jsxs(Flex, {
                align: "center",
                maxW: maxW,
                children: [
                    /*#__PURE__*/ _jsx(Box, {
                        w: "full",
                        children: /*#__PURE__*/ _jsx(Select, {
                            instanceId: instanceId,
                            openMenuOnFocus: true,
                            options: options,
                            onChange: handleChange,
                            value: optimisticSelectedOption || value,
                            isSearchable: true
                        })
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {}),
                    /*#__PURE__*/ _jsx(Box, {
                        ml: 3,
                        w: 8,
                        h: 7,
                        children: isSubmitting || isLoading ? /*#__PURE__*/ _jsx(Spinner, {}) : isConfirmed ? /*#__PURE__*/ _jsx(Icon, {
                            as: CheckIcon,
                            boxSize: 7,
                            color: "green.500"
                        }) : null
                    })
                ]
            }),
            helperText && /*#__PURE__*/ _jsx(FormHelperText, {
                children: helperText
            })
        ]
    }));
};
export default StandaloneSelect;
